export * from './remote-wallbox-firmware-update-version.pipe';
